import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
const LoginView = lazy(() => import('../views/LoginView'));
const SignupView = lazy(() => import('../views/SignupView'));
const ResetPasswordView = lazy(() => import('../views/ResetPasswordView'));
const WizardView = lazy(() => import('../views/WizardView'));
const ManageProfilesView = lazy(() => import('../views/ManageProfilesView/ManageProfilesView.jsx'));
const AdminPanelView = lazy(() => import('../views/AdminPanelView'));
const BillingView = lazy(() => import('@views/Billing/BillingView'));

export const Routing = () => {
  return (
    <Suspense fallback={<></>}>
      <Routes>
        <Route
          path='/wizard/*'
          element={
            <Suspense fallback={<></>}>
              <WizardView />
            </Suspense>
          }
        />
        <Route
          path='/login'
          element={
            <Suspense>
              <LoginView />
            </Suspense>
          }
        />
        <Route
          path='/signup'
          element={
            <React.Suspense fallback={<></>}>
              <SignupView />
            </React.Suspense>
          }
        />
        <Route
          path='/reset'
          element={
            <Suspense fallback={<></>}>
              <ResetPasswordView />
            </Suspense>
          }
        />
        <Route
          path='/dashboard'
          element={
            <Suspense fallback={<></>}>
              <PrivateRoute>
                <ManageProfilesView />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          path='/billing'
          element={
            <Suspense fallback={<></>}>
              <PrivateRoute>
                <BillingView />
              </PrivateRoute>
            </Suspense>
          }
        />
        <Route
          path='/*'
          element={
            <Suspense fallback={<></>}>
              <PrivateRoute>
                <AdminPanelView />
              </PrivateRoute>
            </Suspense>
          }
        />

        <Route path='*' element={<Navigate to='/website' replace />} />
      </Routes>
    </Suspense>
  );
};
